import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@mui/material/Slide';
import {
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@material-ui/core';
import DataContainer from 'Components/UI/DataContainer';
import modalConsts from 'Consts/ModalNames';
import ActionItemsHeader from './ActionItemsHeader';
import ActionItemList from './ActionItemList';

const useStyles = makeStyles(theme => ({
  title: {
    display: 'flex',
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    alignItems: 'center',
    padding: theme.spacing(1),
  },
  content: {
    backgroundColor: theme.palette.facet.lightGray,
  },
  wrapper: {
    maxWidth: theme.dimensions.xxl,
    margin: 'auto',
  },
}));

const Transition = React.forwardRef((props, ref) => (
  <Slide direction="up" ref={ref} {...props} />
));

export default function ActionItemsListDialog(props) {
  const {
    collection, replaceActionItem, refreshActionItems, loading, readOnly,
  } = props;

  const selectedRef = React.useRef();
  const history = useHistory();
  const classes = useStyles();

  const handleClose = () => {
    const search = new URLSearchParams(history.location.search);
    search.set('refresh', 'action-items');
    search.delete('modal');
    history.push({
      search: search.toString(),
    });
  };

  const { location } = history;
  const search = new URLSearchParams(location.search);

  return (
    <Dialog
      fullScreen
      open={search.get(modalConsts.modal) === modalConsts.actionItemList}
      TransitionComponent={Transition}
      onClose={handleClose}
      onEntered={() => {
        if (selectedRef.current) {
          selectedRef.current.scrollIntoView({ behavior: 'smooth' });
        }
      }}
    >
      <DialogTitle disableTypography className={classes.title}>
        <IconButton onClick={handleClose} color="inherit" size="medium">
          <CloseIcon />
        </IconButton>
        <Typography variant="h2" className={classes.titleText}>
          {'My To-Do List'}
        </Typography>
      </DialogTitle>
      <DataContainer loading={loading}>
        <DialogContent className={classes.content}>

          <div className={classes.wrapper}>
            <ActionItemsHeader count={collection.resources().length()} />
            <ActionItemList
              actionItemCollection={collection}
              refreshActionItems={refreshActionItems}
              replaceActionItem={replaceActionItem}
              readOnly={readOnly}
            />
          </div>
        </DialogContent>
      </DataContainer>
    </Dialog>
  );
}

ActionItemsListDialog.defaultProps = {
  readOnly: false,
};

ActionItemsListDialog.propTypes = {
  collection: PropTypes.object.isRequired,
  replaceActionItem: PropTypes.func.isRequired,
  refreshActionItems: PropTypes.func.isRequired,
  readOnly: PropTypes.bool,
  loading: PropTypes.bool.isRequired,
};
